import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UltrasoundImage {
  imageName: string;
  imageFormat: string;
  encodedImage: string;
  fileCreatedDatetime: string;
}
interface UltrasoundGroup {
  imageDate: string;
  imageCount: number;
  ultrasoundImages: UltrasoundImage[];
}
interface PatientUltrasoundDataState {
  ultrasoundImages: UltrasoundGroup[];
}
const initialState: PatientUltrasoundDataState = {
  ultrasoundImages: [],
};
const patientUltrasoundDataSlice = createSlice({
  name: "patientUltrasoundData",
  initialState,
  reducers: {
    setUltrasoundImages(state, action: PayloadAction<UltrasoundGroup[]>) {
      state.ultrasoundImages = action.payload;
    },
  },
});

export const { setUltrasoundImages } = patientUltrasoundDataSlice.actions;
export default patientUltrasoundDataSlice.reducer;
